import { ensureApiSuccess } from './ensureApiSuccess'

// API's interceptor can resolve an HTTP error instead of rejecting it.
export const confirmTimetableRequest = async (request, confirm, {
  confirmedHash,
  checkOnly = false,
  requireSuccessStatus = true,
  isActive = () => true,
} = {}) => {
  let hash = confirmedHash

  while (isActive()) {
    let response
    try {
      response = await request(hash)
    } catch (error) {
      response = error
    }
    const status = response?.response?.status ?? response?.status
    const body = response?.response?.data ?? response?.data
    if (status === 409 && body?.status === 'conflict') {
      if (!isActive()) return null
      const conflicts = body.data
      if (!conflicts?.conflicts_hash || !Array.isArray(conflicts.conflicts)) {
        throw new Error('Не удалось получить список пересечений. Повторите проверку.')
      }
      if (!await confirm(conflicts) || !isActive()) return null
      hash = conflicts.conflicts_hash
      // A preflight never creates lessons and does not need to be confirmed on the server.
      if (checkOnly) return { confirmedHash: hash }
      continue
    }

    ensureApiSuccess(response)
    if (requireSuccessStatus && body?.status !== 'success') {
      const error = new Error('Не удалось выполнить запрос расписания')
      error.response = response
      throw error
    }
    return checkOnly ? (isActive() ? {} : null) : response
  }

  return null
}
